import { useSetAtom } from "jotai";
import { FC } from "react";
import { AuthFlows } from "../../../../constants/authSteps";
import { useMediaQueryBreakpoint } from "../../../../hooks/useMediaQuery";
import { SCREENS } from "../../../../routes/screens";
import { emitAnalyticsTrackingEvent } from "../../../../utils/analyticsUtils";
import {
  Button,
  ButtonVariant,
} from "../../../core-ui/components/Button/Button";
import "./NavLoginContainer.css";
import { useNavigate } from "react-router-dom";
import { authModalOpenAtom } from "../../../../atoms/location/authModalOpenAtom";
import { currentFlowAtom } from "../../../../atoms/location/currentFlowAtom";
import { DesktopNavItems } from "../DesktopNavItems/DesktopNavItems";
interface NavLoginContainerProps {
  column?: boolean;
  onClick?: () => void;
  showSignUpButton?: boolean;
}

export const NavLoginContainer: FC<NavLoginContainerProps> = ({
  column = false,
  onClick,
  showSignUpButton = true,
}: NavLoginContainerProps) => {
  const setFlow = useSetAtom(currentFlowAtom);
  const setAuthModalOpen = useSetAtom(authModalOpenAtom);
  const navigate = useNavigate();
  const { isMobile, isTablet } = useMediaQueryBreakpoint();

  return (
    <div
      className={`nav-login-container ${column ? "nav-login-container--column" : ""}`}
    >
      {!isMobile && <DesktopNavItems />}
      {showSignUpButton && (
        <Button
          className="nav-login-button"
          data-testid={"nav-sign-up"}
          fullWidth
          {...((isMobile || isTablet) && { href: SCREENS.AUTH_SCREEN })}
          onClick={() => {
            emitAnalyticsTrackingEvent("clicked_sign_up", {});
            if (isMobile) {
              navigate(SCREENS.AUTH_SCREEN);
            }
            setFlow(AuthFlows.START_SIGNUP);
            setAuthModalOpen(true);
            if (onClick) {
              onClick();
            }
          }}
          variant={ButtonVariant.OUTLINED}
        >
          Sign up
        </Button>
      )}
      <Button
        className="nav-login-button"
        data-testid={"nav-login"}
        fullWidth
        {...((isMobile || isTablet) && { href: SCREENS.AUTH_SCREEN })}
        onClick={() => {
          emitAnalyticsTrackingEvent("clicked_login", {});
          if (isMobile) {
            navigate(SCREENS.AUTH_SCREEN);
          }
          setFlow(AuthFlows.LOGIN);
          setAuthModalOpen(true);
          if (onClick) {
            onClick();
          }
        }}
      >
        Login
      </Button>
    </div>
  );
};
